

function ezyFormatMoney(cents, format) {
  const value = (cents || 0) / 100;
  const placeholder = (format.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';

  const parts = (precision, thousands, decimal) => {
    const fixed = value.toFixed(precision);
    let [int, dec] = fixed.split('.');
    int = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return precision > 0 && dec ? int + decimal + dec : int;
  };

  let out;
  switch (placeholder) {
    case 'amount_no_decimals':                       out = parts(0, ',', '.'); break;
    case 'amount_with_comma_separator':              out = parts(2, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator':  out = parts(0, '.', ','); break;
    case 'amount_with_apostrophe_separator':         out = parts(2, "'", '.'); break;
    case 'amount_no_decimals_with_space_separator':  out = parts(0, ' ', ','); break;
    case 'amount_with_space_separator':              out = parts(2, ' ', ','); break;
    default:                                         out = parts(2, ',', '.');
  }
  return format.replace(/\{\{\s*\w+\s*\}\}/, out);
}

class EzyBundle extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.unsubscribe?.();
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.moneyFormat = this.dataset.moneyFormat || '{{amount}}';
    this.rows = Array.from(this.querySelectorAll('[data-bundle-row]'));
    this.totalEl = this.querySelector('[data-bundle-total]');
    this.countEl = this.querySelector('[data-bundle-count]');
    this.button = this.querySelector('[data-bundle-add]');
    this.errorEl = this.querySelector('[data-bundle-error]');
    this.cart =
      document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    this.addEventListener('change', (e) => {
      if (e.target.matches('[data-bundle-check], [data-bundle-variant]')) this.refresh();
    }, {signal});
    this.button && this.button.addEventListener('click', this.submit.bind(this), {signal});

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const main = this.querySelector('[data-bundle-row][data-main="true"]');
        if (!main || !data) return;
        if (data.sectionId && String(data.sectionId) !== this.dataset.sectionId) return;
        if (!data.variant) { main.dataset.available = 'false'; this.refresh(); return; }
        const photo = data.variant.featured_media?.preview_image || data.variant.featured_image;
        const imageUrl = typeof photo === 'string' ? photo : photo?.src;
        const thumbnail = main.querySelector('img');
        if (thumbnail && imageUrl) thumbnail.src = imageUrl;
        main.dataset.variantId = data.variant.id;
        main.dataset.price = data.variant.price;
        main.dataset.available = data.variant.available ? 'true' : 'false';
        const priceEl = main.querySelector('[data-bundle-price]');
        if (priceEl) priceEl.textContent = ezyFormatMoney(data.variant.price, this.moneyFormat);
        this.refresh();
      });
    }

    this.refresh();
  }

  disconnectedCallback() {
    this.unsubscribe && this.unsubscribe();
    this.controller?.abort();
  }

  
  selected() {
    return this.rows.filter((row) => {
      const check = row.querySelector('[data-bundle-check]');
      if (!check || !check.checked) return false;
      return this.variantOf(row).available;
    });
  }

  variantOf(row) {
    const select = row.querySelector('[data-bundle-variant]');
    if (select) {
      const opt = select.options[select.selectedIndex];
      return {
        id: select.value,
        price: parseInt(opt.dataset.price || '0', 10),
        available: opt.dataset.available !== 'false',
      };
    }
    return {
      id: row.dataset.variantId,
      price: parseInt(row.dataset.price || '0', 10),
      available: row.dataset.available !== 'false',
    };
  }

  refresh() {

    this.rows.forEach((row) => {
      const v = this.variantOf(row);
      const check = row.querySelector('[data-bundle-check]');
      const status = row.querySelector('[data-bundle-status]');
      const priceEl = row.querySelector('[data-bundle-price]');
      if (priceEl && !row.dataset.main) {
        priceEl.textContent = ezyFormatMoney(v.price, this.moneyFormat);
      }
      row.classList.toggle('ezy-bundle__row--disabled', !v.available);
      if (check?.hasAttribute('data-locked')) check.checked = v.available;
      else if (check && !v.available) check.checked = false;
      if (check) check.disabled = !v.available || check.hasAttribute('data-locked');
      if (status) status.hidden = v.available;
    });

    const chosen = this.selected();
    const total = chosen.reduce((sum, row) => sum + this.variantOf(row).price, 0);
    if (this.totalEl) this.totalEl.textContent = ezyFormatMoney(total, this.moneyFormat);
    if (this.countEl) this.countEl.textContent = String(chosen.length);
    const main = this.rows.find(row => row.dataset.main === 'true');
    if (this.button) this.button.disabled = this.submitting || chosen.length === 0 || !main || !this.variantOf(main).available;
  }

  async submit() {
    if (this.submitting || this.button.disabled) return;
    const chosen = this.selected();
    if (!chosen.length) return;
    this.submitting = true; this.button.disabled = true;

    this.button.classList.add('loading');
    this.button.setAttribute('aria-disabled', 'true');
    if (this.errorEl) this.errorEl.hidden = true;

    const body = {
      items: chosen.map((row) => ({ id: Number(this.variantOf(row).id), quantity: 1 })),
    };
    if (this.cart && this.cart.getSectionsToRender) {
      body.sections = this.cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
      this.cart.setActiveElement && this.cart.setActiveElement(document.activeElement);
    }

    try {
      const res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(body),
      });
      const data = await res.json();

      if (!res.ok || data.status) throw new Error(data.description || data.message || this.dataset.errorMessage);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ezy-bundle', cartData: data });
      }
      if (this.cart && this.cart.renderContents) {
        this.cart.classList.remove('is-empty');
        this.cart.renderContents(data);
      } else {
        window.location = window.routes.cart_url;
      }
    } catch (err) {
      if (this.errorEl) {
        this.errorEl.textContent = err.message || this.dataset.errorMessage;
        this.errorEl.hidden = false;
      }
    } finally {
      this.button.classList.remove('loading');
      this.button.removeAttribute('aria-disabled');
      this.submitting = false; this.refresh();
    }
  }
}

if (!customElements.get('ezy-bundle')) customElements.define('ezy-bundle', EzyBundle);

